// extracted by mini-css-extract-plugin
export default {"root":"IronBody_root__FGcVV"};